import React from 'react';
import * as rxjs from 'rxjs';

import * as Elevated from '@pitaman71/omniglot-introspect';
import { Annotations, Clients, Streams } from '@pitaman71/omniglot-live-data';

import { makeStyles, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

const __moduleName__ = `omniglot-live-react/MaterialUi/AsSelector`;

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      display: 'flex',
      wrap: 'nowrap'
    },
    select: {
        margin: theme.spacing(1),
        width: '22ch',
    },  
}));
  
export function OfScalar<ContentType extends string|number, DomainType extends Elevated.Domain<ContentType>>(props: Partial<Annotations.Annotation<JSX.Element>> & {
    maxCount: number,
    ascending: boolean,
    stream: Streams.ScalarStream<ContentType, DomainType>,
    noneLabel?: string
}) {
    const values: ContentType[] = Array.from(props.stream.domain.asEnumeration(props.maxCount)?.forward() || []);
    const elementRef = React.useRef<HTMLDivElement>(null);
    const [ value, setValue ] = React.useState<ContentType|undefined>(undefined);
    const [ status, setStatus ] = React.useState<Streams.Status>({ initializing: true })
    const classes = useStyles();

    const client = Clients.ScalarClient.fromDelta<ContentType, DomainType>(`${__moduleName__}/OfScalar(${props.stream.persistKey})`, setValue, setStatus);
    const [ subscription, setSubscription ] = React.useState<Streams.Subscriptions|undefined>();

    React.useEffect(() => {
        if(subscription) {
            subscription.unsubscribe();
        }
        setSubscription(client.watchParent(props.stream));
        return (() => {
            if(subscription) {
                subscription.unsubscribe();
            }    
        })
    }, [ ])

    return (
        <React.Fragment>
            <InputLabel shrink style={{ display: 'flex' }}>
                {props.label}
            </InputLabel>
            <FormControl className={classes.formControl}>
                <Select className={classes.select}
                    value={value === undefined ? "" : value }
                    onChange={ ((event:any) => {
                        const stateful = props.stream.stateful();
                        if(!stateful) {
                            // do nothing
                        } else if(event.target.value === '') {
                            stateful.clear();
                        } else {
                            stateful.assign(event.target.value)
                        }
                    }) }
                > 
                    { !props.noneLabel && <MenuItem value={""}>&nbsp;</MenuItem> }
                    { !!props.noneLabel && <MenuItem value={""}>{props.noneLabel}</MenuItem> }
                    {
                        values.map(value_ => <MenuItem value={value_}>{value_}</MenuItem>)
                    }
                </Select>
            </FormControl>
        </React.Fragment>
    );
}
